import _sfc_main from "./component-library204.mjs";
import "./component-library205.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.isPossible ? _c("span", { staticClass: "charger" }, [_setup.isIncluded !== null ? _c(_setup.ChargerBox, { attrs: { "is-included": _setup.isIncluded } }) : _vm._e(), _setup.wattsText ? _c(_setup.ChargerLabel, { attrs: { "pd": _setup.hasPd, "watts": _setup.wattsText } }) : _vm._e()], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "b33964ff",
  null,
  null
);
const charger = __component__.exports;
export {
  charger as default
};
